<template>
  <div>
    <h1>Blocked address</h1>

    <div class="border small-padding flex full-width">
      <div class="flex-basis">
        <div class="flex">
          <MaterialText v-model="address" label="Street name" />
          <MaterialText v-model="street_number" label="Street number" />
        </div>
        <div class="margin-top flex">
          <MaterialText v-model="door" label="House/door number" />
        </div>
        <div class="margin-top flex">
          <MaterialText v-model="zipcode" label="Zipcode" class="short small-margin-right" width="100" />
          <MaterialText v-model="city" label="City" />
        </div>
        <div class="margin-top">
          <MaterialDropdown label="Country" :options="countries" v-model="country_id" />
        </div>
        <div class="margin-top flex">
          <MaterialText v-model="user_id" label="Customer ID" />
        </div>
        <div>
          <button v-on:click="createBlockedAddress()" class="small-margin-top" :disabled="saving">
            Create blocked address
          </button>
        </div>
      </div>
    </div>
    <div class="margin-top">
      <Table class="margin-top" :rows="list" :columns="columns" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BlockedAddress',
  data: () => ({
    loading: false,
    blockedList: [],
    address: '',
    street_number: '',
    door: '',
    zipcode: '',
    user_id: '',
    city: '',
    country_id: '',
    saving: false,
    columns: {
      id: {
        name: 'ID'
      },
      user_id: {
        name: 'Customer ID'
      },
      address: {
        name: 'Street name'
      },
      street_number: {
        name: 'Street number'
      },
      door: {
        name: 'House/Door number'
      },
      zipcode: {
        name: 'Zipcode'
      },
      city: {
        name: 'City'
      },
      country_id: {
        name: 'Country',
        type: 'flag'
      },
      blocked: {
        name: 'Blocked'
      }
    }
  }),
  computed: {
    ...mapGetters([
      'getCountries'
    ]),
    countries () {
      return Vue.$array.keyValue(this.getCountries, 'id', 'name')
    },
    list () {
      const blockedList = []
      for (var i in this.blockedList) {
        const blocked = this.blockedList[i]
        blocked.blocked = !blocked.unblocked
        blocked.menu = [
          {
            name: 'Delete',
            onClick: (row) => {
              this.deleteBlockedAddress(row)
            }
          }
        ]
        const unblockButton = {
          name: 'Unblock',
          onClick: (row) => {
            this.unblockAddress(row)
          }
        }
        const blockButton = {
          name: 'Block',
          onClick: (row) => {
            this.blockAddress(row)
          }
        }
        if (blocked.unblocked) {
          blocked.menu.push(blockButton)
        } else {
          blocked.menu.push(unblockButton)
        }
        blockedList.push(blocked)
      }
      return blockedList
    }
  },
  methods: {
    getList () {
      Vue.$api.get('/address/blocked/list', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.blockedList = data
        }
      })
    },
    createBlockedAddress () {
      Vue.$api.post('/address/blocked/store', {
        address: this.address,
        street_number: this.street_number,
        door: this.door,
        zipcode: this.zipcode,
        city: this.city,
        country_id: this.country_id,
        user_id: this.user_id
      }, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    deleteBlockedAddress (row) {
      Vue.$api.delete('/address/blocked/' + row.id + '/delete', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    unblockAddress (row) {
      Vue.$api.post('/address/blocked/' + row.id + '/unblock', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    blockAddress (row) {
      Vue.$api.post('/address/blocked/' + row.id + '/block', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>

</style>
